import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { usePageStore } from '@/store';
import { formats } from '../../common/format';
import { normal } from '../defaultSpacing';
import { asyncData } from './asyncData';
import { mapAsyncData } from '@/plugins/asyncData';




import * as TYPES from "./_store/types";
import { buildUrl } from '@/router/index.js';

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-similar-home'
    },
    data: function() {
        let config = {
            title: '',
            ...normal,
            showSubTitle: true,
            listingDetail: null, // real estate id
            size: 3,
            isLandingpage: false,
            listingLink: buildUrl({ name: 'listing' })
        };
        return { ...config };
    },
    asyncData: mapAsyncData(asyncData),
    methods: {
        ...mapActions({
            "setStartIndex": TYPES.SET_START_INDEX,
            "setCurrentList": TYPES.SET_CURRENT_LIST
        }),
        
        unlike() {
            let currentList = [];
            let startIndex = this.startIndex;
            for (let i = 0; i < this.size; i++) {
                if (startIndex > this.list.length - 1) {
                    startIndex = 0;
                }
                currentList.push(this.list[startIndex]);
                startIndex++;
            }

            this.setStartIndex(startIndex);
            this.setCurrentList(currentList);
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            "currencySymbol": store => store.currency.symbol,
            "page": store => store.page
        }),
        ...mapState({
            "list": store => store.list,
            "currentList": store => store.currentList,
            "startIndex": store => store.startIndex
        }),
        
        
        exist() {
            if (this.list && this.list.length > 0) {
                return true; 
            }
            if (this.isLandingpage) {
                return true; 
            }
            return false;
        },
        visible() {
            if (this.list && this.list.length > 0) {
                return true; 
            }
            return false;
        },
        subTitle() {
            const info = (this.listingDetail && this.listingDetail.info) || {};
            const property = this.$t(
                `common:${info.propertyType || info.propertyTypePrimary || 'Propertie'
                }`
            );

            console.log('-----page----', this.page);
            const priceKey = /sold/.test(this.page.pageKey)
                ? 'soldPrice'
                : 'price';
            const addr = [info.city, info.state || info.zipCode]
                .filter(Boolean)
                .join(',');
            return info[priceKey]
                ? this.$t('md-similar-home.checkForSimilarPropertyAtPrice', {
                    property,
                    price:
                        this.currencySymbol + formats.number(info[priceKey]),
                    addr
                })
                : this.$t('md-similar-home.checkForSimilarProperty', {
                    property,
                    addr
                });
        }
    }
};
